import WidgetModule from "@eisinc/Overrides/Widgets/Common/CartLink";

export * from "@eisinc/Overrides/Widgets/Common/CartLink";

export default WidgetModule;
